// extracted by mini-css-extract-plugin
export default {"resetButton":"rL1JB9w","root":"KQUDJDu","alarm":"SmVhTcE"};